import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { OrderContactSlice } from './contact-types'

const INITIAL_STATE: OrderContactSlice = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  optIn: false,
  optInSms: false,
  isNameAnonymous: false,
  isAmountAnonymous: false,
  isCompanyCard: false,
  cardCompanyName: '',
}

const orderContactSlice = createSlice({
  name: 'contact',
  initialState: INITIAL_STATE,
  reducers: {
    setValue: (state, payload: PayloadAction<OrderContactSlice>) => {
      return { ...state, ...payload.payload }
    },
  },
})

export default orderContactSlice
